/* eslint-disable linebreak-style */

import {
  ArrowLeftOutlined,
  CloudUploadOutlined,
  FileExcelOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';
import { Button, Form, Input, Modal, notification, Tooltip, Typography, Upload } from 'antd';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import { get } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';

import {
  DeleteOutlined,
  EditOutlined,
  UnlockOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons';
import AddUserModal from '../../components/AddUserModal';
import {
  getUsers,
  getAccess,
  getAllUsersList,
  getAllUsersGroupsList,
} from '../../services/teamMembers';
import {
  saveUsers,
  removeAccess,
  resetUserPassword,
  sendUserEmail,
  addAccess,
  removeUser,
} from '../../services/userManagement';
import ResetPasswordModal from '../../components/ResetPasswordModal';
import { CustomLoadingCellRenderer } from '../../components/Calibration/Uitiles';
import CommonAGGridTable from '../../components/AG Grid/CommonAGGridTable';

const { Title, Text } = Typography;

const UserManagementAGGrid = (props) => {
  const {} = props;

  const [theme, setTheme] = useState('ag-theme-material-dark'); // Default theme
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([]);

  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [pageSize, setPageSize] = useState(100000);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadingData, setloadingData] = useState(false);
  const [selectModel, setSelectModel] = useState([]);

  const [userModalVisible, setUserModalVisible] = useState(false);
  const [userModalLoading, setUserModalLoading] = useState(false);
  const [resetPasswordModalVisible, setResetPasswordModalVisible] = useState(false);
  const [resetPasswordModalLoading, setResetPasswordModalLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userData, setUserData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [disableSendEmail, setDisableSendEmail] = useState(false);
  const [teamModalLoading, setTeamModalLoading] = useState(false);
  const [createUserLoader, setCreateUserLoader] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [userForm] = Form.useForm();
  const [resetPasswordForm] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTokens, setPageTokens] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [userName, setUserName] = useState('');
  const [userGroup, setUserGroup] = useState([]);
  const [resetPasswordRecord, setResetPasswordRecord] = useState([]);
  const [searchKeyExist, setSearchKeyExist] = useState('');
  const [maxmUsersPerPage, setMaxUsersPerPage] = useState(0);
  const [userGroupsList, setUserGroupsList] = useState([]);

  const getUsersList = async (pageToken, pageAction, searchKeyExist) => {
    setShowLoader(true);
    const response = await getAllUsersList();
    if (response && response.users.length) {
      setPageTokens([...pageTokens, response.paginationToken]);
      setUserCount(response.count);
      // eslint-disable-next-line consistent-return
      let usersForProject = response.users.map((obj) => {
        const details = { user_id: obj.Username };
        obj.Attributes.forEach((element) => {
          if (element.Name === 'custom:first_name') {
            details.userFirstName = element.Value;
          } else if (element.Name === 'custom:last_name') {
            details.userLastName = element.Value;
          } else if (element.Name === 'email') {
            details.email = element.Value;
          }
        });
        details.userLastName
          ? (details.name = details.userFirstName + ' ' + details?.userLastName)
          : (details.name = details.userFirstName);
        details.userStatus = obj.UserStatus;
        details.enabled = obj.Enabled;
        if (details.name && details.email && details.userStatus && details.enabled) {
          return details;
        }
      });
      usersForProject = usersForProject.filter((el) => el);
      usersForProject.sort((a, b) => a.name.localeCompare(b.name));
      setUserData(usersForProject);
      if (maxmUsersPerPage === 0) {
        setMaxUsersPerPage(usersForProject.length);
      }
      if (pageAction == 'next') {
        setTotalUsers(totalUsers + usersForProject.length);
      } else if (pageAction == 'prev') {
        setTotalUsers(totalUsers - usersForProject.length);
      } else {
        setTotalUsers(usersForProject.length);
      }
      setShowLoader(false);
    } else if (response.users.length == 0) {
      // notification.warning({
      //   message: 'User does not exist with the given email.',
      //   duration: 1.2
      // });
      console.log('User does not exist with the given email');
      setUserData(null);
      setShowLoader(false);
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getUsersList();

      if (userGroupsList.length === 0) {
        const response = await getAllUsersGroupsList();
        if (response) setUserGroupsList(response);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showResetPasswordModal = (record) => {
    setResetPasswordRecord(record);
    setResetPasswordModalVisible(true);
  };

  const handleDeletion = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to remove this user?',
      className: 'custom-text-clr',
      async onOk() {
        return removeUser(record.user_id, record.email)
          .then((res) => {
            if (res) {
              notification.success({
                message: 'User deleted successfully',
              });
              getUsersList();
            } else {
              notification.error({
                message: 'Something went wrong.',
              });
            }
            return true;
          })
          .catch(() =>
            notification.error({
              message: 'Something went wrong.',
            })
          );
      },
      onCancel() {},
    });
  };

  const saveUser = async (data) => {
    const res = await saveUsers(data);
    if (res === 200) {
      setDisableSendEmail(true);
      notification.success({
        message: 'User created successfully',
        duration: 1.2,
      });
      getUsersList();
    } else {
      notification.warning({
        message: 'User with the given email already exists.',
        duration: 1.2,
      });
      setCreateUserLoader(false);
    }
    // userForm.resetFields();
    setCreateUserLoader(false);
    setUserModalLoading(false);
    //setDisableSendEmail(false);
    //setUserModalVisible(false);
  };

  const sendEmail = async (data) => {
    const response = await sendUserEmail(data);
    if (response) {
      notification.success({
        message: 'Email sent successfully',
      });
      userForm.resetFields();
      setCreateUserLoader(false);
      setDisableSendEmail(false);
      setUserModalVisible(false);
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  };

  const resetPassword = async (data) => {
    resetPasswordForm.resetFields();
    const response = await resetUserPassword(data);
    if (response) {
      notification.success({
        message: 'Password has been reset successfully',
      });
    } else {
      notification.success({
        message: 'Something went wrong',
      });
    }
    setResetPasswordModalLoading(false);
    setResetPasswordModalVisible(false);
  };

  const showAddEditUserModal = async (record, edit) => {
    console.log(record);
    let userDt = {};
    if (record !== '') {
      const response = await getAccess(record.user_id);
      const userAccess = response.map((item) => item?.GroupName);
      const fullName = record.name.split(' ');
      const fName = fullName[0];
      if (fullName.length === 2) {
        const lName = fullName[1];
        userDt = {
          email: record.email,
          firstName: fName,
          lastName: lName,
          access: userAccess,
        };
      } else {
        userDt = {
          email: record.email,
          firstName: fName,
          access: userAccess,
        };
      }
      userForm.setFieldsValue(userDt);
      setUserName(record.user_id);
      setUserGroup(userAccess);
    } else {
      userForm.resetFields();
    }

    setIsEdit(edit);

    setUserModalVisible(true);
  };

  const onAdduserToGroup = async (dataList) => {
    try {
      setUserModalLoading(true);
      const failedGroups = [];

      // Loop through all data and process them
      for (const data of dataList) {
        const response = await addAccess(data);
        if (response !== 200) {
          failedGroups.push(data); // Store failed attempts
        }
      }

      // Show notification based on success or failure
      if (failedGroups.length > 0) {
        notification.error({
          message: `Failed to add ${failedGroups.length} group(s).`,
          duration: 1.5,
        });
      } else {
        notification.success({
          message: 'User added to groups successfully',
          duration: 1.5,
        });
      }

      await getUsersList(); // Refresh user list
    } catch (error) {
      notification.error({
        message: 'Something went wrong.',
      });
    } finally {
      setUserModalLoading(false);
      setCreateUserLoader(false);
      setUserModalVisible(false);
    }
  };

  const onRemoveuserFromGroup = async (dataList) => {
    try {
      setUserModalLoading(true);
      const failedGroups = [];

      // Loop through all data and process them
      for (const data of dataList) {
        const response = await removeAccess(data);
        if (response !== 200) {
          failedGroups.push(data); // Store failed attempts
        }
      }

      // Show notification based on success or failure
      if (failedGroups.length > 0) {
        notification.error({
          message: `Failed to remove ${failedGroups.length} group(s).`,
          duration: 1.5,
        });
      } else {
        notification.success({
          message: 'User removed from groups successfully',
          duration: 1.5,
        });
      }

      await getUsersList(); // Refresh user list
    } catch (error) {
      notification.error({
        message: 'Something went wrong.',
      });
    } finally {
      setUserModalLoading(false);
      setCreateUserLoader(false);
      setUserModalVisible(false);
    }
  };

  const columnList = {
    name: 'Name',
    email: 'Email',
    userStatus: 'Confirm Status',
  };

  const generateColumns = async (columnList) => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'sno',
        maxWidth: 200,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Name',
        field: 'name',
        width: 200,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Email',
        field: 'email',
        width: 250,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Confirm Status',
        field: 'userStatus',
        width: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Actions',
        field: 'actions',
        width: 200,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        pinned: 'right',
        filter: false,
        cellRenderer: (params) => {
          const record = params.data;
          if (!record) return <div>-</div>;

          return (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
              <Tooltip
                arrowPointAtCenter
                placement="topRight"
                title="Edit User Access"
              >
                <Button
                  className="p-0 border-0"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => showAddEditUserModal(record, true)}
                >
                  <EditOutlined style={{ fontSize: '18px' }} />
                </Button>
              </Tooltip>
              <Tooltip
                arrowPointAtCenter
                placement="topRight"
                title="Reset User Password"
              >
                <Button
                  className="p-0 border-0"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => showResetPasswordModal(record, true)}
                >
                  <UnlockOutlined style={{ fontSize: '18px' }} />
                </Button>
              </Tooltip>
              <Tooltip
                arrowPointAtCenter
                placement="topLeft"
                title="Delete User"
              >
                <Button
                  className="p-0 border-0"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => handleDeletion(record)}
                >
                  <DeleteOutlined style={{ fontSize: '18px' }} />
                </Button>
              </Tooltip>
            </div>
          );
        },
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };

  useEffect(() => {
    generateColumns(columnList);
  }, []);

  const fetchData = async (data) => {
    if (data.length > 0) {
      //generateColumns(data[0]);
      setRowData(data);
      setLoadingProgress(100);
    }
  };

  useEffect(() => {
    console.log('user List:', userData);
    if (userData && userData.length > 0) {
      userData.map((item, i) => {
        item.sno = i + 1;
      });
      fetchData(userData);
    }
  }, [userData]);

  const treeData = [
    {
      title: 'Super Admin',
      key: 'admin',
    },
    {
      title: 'Admin',
      key: 'super-admin',
    },
    {
      title: 'Projects',
      key: 'web-page',
    },
    {
      title: 'Analysis',
      key: 'analysis',
    },
    {
      title: 'Ask Evans',
      key: 'AskEvans',
      children: [
        {
          title: 'Admin',
          key: 'askevans-training-data',
        },
      ],
    },
    {
      title: 'Technical',
      key: 'technical',
      children: [
        {
          title: 'Heat Profile',
          key: 'heat-profile',
        },
        {
          title: 'Coating Record Database',
          key: 'coating-record-db',
        },
        {
          title: 'DCAL Generator',
          key: 'dcal-generators',
          children: [
            {
              title: 'Admin',
              key: 'dcal-generator-master',
            },
            {
              title: 'Normal User',
              key: 'dcal-generator',
            },
          ],
        },
      ],
    },
    {
      title: 'Calibration & Control',
      key: 'Calibration-Control',
      children: [
        {
          title: 'Normal user',
          key: 'calibration-normal-user',
        },
      ],
    },
  ];

  const handleDownloadData = async () => {
    setDownloadLoading(true);

    const treeColumns = [];

    const processTree = (nodes, parentTitle) => {
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          processTree(node.children, node.title); // Recurse with parent title
        } else {
          const header = parentTitle ? `${parentTitle} - ${node.title}` : node.title;
          treeColumns.push({
            header,
            key: node.key,
            width: 40,
          });
        }
      });
    };

    // Process tree data to generate dynamic columns
    processTree(treeData);

    const workbook = new ExcelJS.Workbook();
    const databaseList = rowData;

    if (databaseList && databaseList.length > 0) {
      const sheet = workbook.addWorksheet('User List');
      const headerRow = sheet.getRow(1);
      headerRow.height = 20;

      const columns = [
        ...Object.keys(columnList)
          .filter((key) => key !== 'ID')
          .map((key) => ({
            header: columnList[key],
            key,
            width: 40,
          })),
        ...treeColumns,
      ];

      sheet.columns = columns;

      const usersWithGroups = databaseList.map((user) => ({
        ...user,
        Groups: userGroupsList?.users[user.user_id] ?? [],
      }));
      // Ensure each row has all treeData keys and mark group memberships
      const filledData = usersWithGroups.map((user) => {
        const extendedRow = { ...user };

        // Add group flags based on treeColumns
        treeColumns.forEach((col) => {
          // If this group exists in user's group list, mark it
          extendedRow[col.key] = user.Groups.includes(col.key) ? '✔' : '';
        });

        return extendedRow;
      });

      sheet.addRows(filledData);
    }

    // Export Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `List of User ${moment().format('DD-MM-YYYY')}.xlsx`;
    link.click();

    setDownloadLoading(false);
  };

  const getAgGridTable = () => {
    return (
      <div>
        <CommonAGGridTable
          rowData={userData}
          columnDefs={columnDefs}
          activeKeyLine="List of Users"
          isRawListLoading={userData.length === 0 || showLoader}
          loadingMessage="Loading Users..."
          //onSelectionChanged={handleSelectionChanged}
        />
      </div>
    );
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex mt-0.5 justify-content-between  tab-content-title">
        <div className="d-flex align-items-center">
          <Title
            className="mb-0"
            level={4}
          >
            List of Users
          </Title>
        </div>

        <div className="text-right new-calibration new-calibration new-project-team">
          {rowData && rowData.length > 0 && (
            <Text
              onClick={() => {
                handleDownloadData();
              }}
              className="ps-3 add-new-team"
            >
              <span className="icon-22">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 3v18M5 12l7 7 7-7"></path>
                </svg>
              </span>
              Download As Excel
            </Text>
          )}
          <Text
            onClick={() => showAddEditUserModal('', false)}
            className="ps-3 add-new-calibration"
          >
            <span className="icon-22">
              <svg>
                <use xlinkHref="#add" />
              </svg>
            </span>
            Create New User
          </Text>
        </div>
      </div>

      <div className="custom-line" />

      {getAgGridTable()}

      {userModalVisible ? (
        <AddUserModal
          setUserModalVisible={setUserModalVisible}
          setUserModalLoading={setUserModalLoading}
          userModalVisible={userModalVisible}
          userModalLoading={userModalLoading}
          userForm={userForm}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          onSave={saveUser}
          setCreateUserLoader={setCreateUserLoader}
          createUserLoader={createUserLoader}
          disableSendEmail={disableSendEmail}
          OnSendEmail={sendEmail}
          setDisableSendEmail={(value) => setDisableSendEmail(value)}
          userGroup={userGroup}
          setUserGroup={setUserGroup}
          setUserName={setUserName}
          userName={userName}
          OnRemoveuserFromGroup={onRemoveuserFromGroup}
          OnAdduserToGroup={onAdduserToGroup}
        />
      ) : null}
      {resetPasswordModalVisible ? (
        <ResetPasswordModal
          setResetPasswordModalVisible={setResetPasswordModalVisible}
          resetPasswordModalVisible={resetPasswordModalVisible}
          setResetPasswordModalLoading={(value) => setResetPasswordModalLoading(value)}
          resetPasswordModalLoading={resetPasswordModalLoading}
          resetPasswordForm={resetPasswordForm}
          setResetPasswordRecord={setResetPasswordRecord}
          teamModalLoading={teamModalLoading}
          setTeamModalLoading={setTeamModalLoading}
          onResetPassword={resetPassword}
          resetPasswordRecord={resetPasswordRecord}
        />
      ) : null}
    </div>
  );
};

export default connect(null, null)(UserManagementAGGrid);
